module.exports = __webpack_public_path__ + "img/img04.b1b11aeb.png";